module.exports = __webpack_public_path__ + "img/IMG_8965.9b5fc71a.jpg";